import { useMemo } from 'react'
import styled from 'styled-components'

import { reatomPairHoldersTable } from '@root/widgets/trade/tables/holders-table/atoms/reatom-pair-holders-table'
import { HoldersTable } from '@root/widgets/trade/tables/holders-table/ui/holders-table'

import type { PairModel } from '@root/entities/pair'

type TradePairHoldersTableProps = {
  pair: PairModel
}

export const TradePairHoldersTable: React.FC<TradePairHoldersTableProps> = ({
  pair,
}) => {
  const pairHoldersModelAtom = useMemo(() => {
    // eslint-disable-next-line @reatom/unit-naming-rule
    return reatomPairHoldersTable({
      pair,
    })
  }, [pair])

  const context = useMemo(
    () => ({
      pairAddress: pair.address,
    }),
    [pair.address],
  )

  return <Root tableModel={pairHoldersModelAtom} context={context} />
}

const Root = styled(HoldersTable)`
  height: 100%;
`
